import { render, staticRenderFns } from "./ProNav.vue?vue&type=template&id=5f34719c&scoped=true&lang=pug&"
import script from "./ProNav.vue?vue&type=script&lang=js&"
export * from "./ProNav.vue?vue&type=script&lang=js&"
import style0 from "./ProNav.vue?vue&type=style&index=0&id=5f34719c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34719c",
  null
  
)

export default component.exports